import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Util, runtime } from '../common';
import Button, { HelpLink } from './Button';
import _SweetAlert from 'react-bootstrap-sweetalert';
import { SwipeableDrawer, Snackbar as _Snackbar, Backdrop } from '@material-ui/core';
import { Scrollbar } from './Base';
import PropTypes from "prop-types";

// function Transition(props) {
//   return <Slide direction="up" {...props} />;
// } //full下报错

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class Modal extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      open: props.open || false
    }
  }

  componentWillReceiveProps(nextProps) {
    let { open } = nextProps;
    if (open === false || open) {
      if (open != this.props.open)
        this.setState({ open });
    }
  }

  open(p) {
    this.config = p || {};
    this.setState({ open: true });
  };

  close(p) {
    this.config = { ...this.config, ...p };
    this.setState({ open: false });
    let { keepMounted } = this.props;
    if(keepMounted) this.handleEvent("onExit");  //如果是keepMounted状态，那么实际上窗口没被销毁，就不能触发onExit事件，所以此处主动触发下
  };

  handleEvent(e) {
    let p = {...this.config,...this.props};
    if (p[e]) p[e]();
  }

  renderTools() {
    let { showClose, tools } = this.props;
    if (tools) return tools;
    return showClose !== false ? <IconButton  key={1} onClick={() => { this.close() }} aria-label="Close">
      <CloseIcon />
    </IconButton> : null;
  }

  renderTitle() {
    let { title, showClose, tools, header, titleClassName,help } = this.props;
    return title || header ? <AppBar className="position-relative no-shadow" color="inherit">
      <Toolbar disableGutters={true} className={`c-lb no-shadow px-3 px-sm-0 mx-0 mx-sm-3 mx-md-4 ${titleClassName}`}>
        {
          header ? header : [<div key={0} className="d-flex flex-row c-flex-1 justify-content-start align-items-center ">
                              <p className={"mb-0 text-dark c-text-s3 c-ellipsis-1"}>{title}</p>
                              {help?<HelpLink className="ml-2" size="md" href={help} />:null}
                              </div>,
          this.renderTools()]
        }
      </Toolbar>
    </AppBar> : null
  }

  renderBody() {
    let { drawer, size } = this.props;
    if (size === "auto") {
      return this.props.children;
    }
    if (drawer === "right" || drawer === "left") {
      let { containerFull, containerSpace, containerClassName } = this.props;
      return <Scrollbar className="scrollbar">
        <div className={`mx-3 ${containerSpace ? 'mx-md-4' : ''} ${containerClassName} ${containerFull?"h-100":""}`}>
          {this.props.children}
        </div>
      </Scrollbar>
    }
    else {
      let { height, containerClassName } = this.props;
      if (height) {
        return <Scrollbar className="scrollbar" style={{ height }}>
          <div className={`mx-0  ${containerClassName}`}>
            {this.props.children}
          </div>
        </Scrollbar>
      } else {
        //自适应大小
        return <div className={`mx-0  ${containerClassName}`}>
          {this.props.children}
        </div>
      }
    }
  }

  renderFull() {
    let { title, showClose } = this.props;
    return (
      <Dialog
        fullScreen
        open={this.state.open}
        TransitionComponent={Transition}
        onEntered={() => this.handleEvent("onEntered")}
        onExit={() => this.handleEvent("onExit")}
      >
        {this.renderTitle()}
        {this.renderBody()}
      </Dialog>
    );
  }

  renderSize() {
    let { title, size, showClose } = this.props;
    return (
      <Dialog
        fullWidth={true}
        maxWidth={size}
        open={this.state.open}
        onEntered={() => this.handleEvent("onEntered")}
        onExit={() => this.handleEvent("onExit")}
      >
        {this.renderTitle()}
        {this.renderBody()}
      </Dialog>
    );
  }


  renderDrawer() {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    let { drawer, size, backdrop, disableEnforceFocus, paperProps,keepMounted } = this.props;

    //let modalProps = backdrop===false?{BackdropComponent:BackdropSlim}:null;
    let modalProps = {keepMounted};
    if (backdrop === false) modalProps.hideBackdrop = true;

    return <SwipeableDrawer
      className={`c-drawer ${size === 'auto' ? '' : `c-drawer-${size}`} ${backdrop === false ? 'c-drawer-backdrop-none' : ''}`}
      disableBackdropTransition={!iOS} disableDiscovery={iOS} swipeAreaWidth={0}  //必须为0，不然可以触摸弹出窗口，体验很不好
      ModalProps={{ ...modalProps }}
      PaperProps={{ ...paperProps }}
      anchor={drawer}
      disableEnforceFocus={disableEnforceFocus}
      onOpen={() => { this.setState({ open: true }); }}
      open={this.state.open}
      onClose={() => { this.setState({ open: false }); }} 
    >
      {this.renderTitle()}
      {this.renderBody()}
      <Temp onEntered={() => this.handleEvent("onEntered")}
        onExit={() => this.handleEvent("onExit")} />
    </SwipeableDrawer>;
  }


  full() {
    let { full, size } = this.props;
    return full || size == "full";
  }

  render() {
    let { drawer } = this.props;
    if (drawer) return this.renderDrawer();
    if (this.full()) return this.renderFull();
    return this.renderSize();
  }
}

Modal.pageProps = { //将modal模拟成一个page的效果
  containerFull:true,
  titleClassName:"c-px-3 c-mx-0", 
  containerClassName:"c-bg-body c-px-0 c-mx-0",
  size:"full"
}


class Temp extends React.Component {

  componentDidMount() {
    this.props.onEntered();
  }

  componentWillUnmount() {
    this.props.onExit();
  }

  render() {
    return null;
  }
}

Modal.defaultProps = {
  size: "lg",
  drawer: "right",
  full: false,
  containerSpace: true,
  containerClassName: '',
  titleClassName: '',
  disableEnforceFocus: true  //默认值原本是false,为false的时候，窗口外部的元素是无法获得输入焦点的，如果窗口内部有文本编辑器，那么文本编辑器有弹窗（比如插入链接）的时候，就无法输入了，所以这里默认值为true,表示窗体不再屏蔽外部焦点
}


//专门用于从底部或者顶部弹出的modal
export class Sheet extends React.Component {

  open(p) {
    this.refs.modal.open(p);
  };

  close(p) {
    this.refs.modal.close(p);
  };

  render() {
    var p = { ...this.props };
    delete p.ref; delete p.size;
    return (
      //当有header，我们不希望容器和header一起滚动，仅容器内部滚动
      <Modal ref="modal" size="full" drawer="bottom" containerClassName={p.header ? "c-scroll" : ''} paperProps={{ className: "c-mxh80" }} {...p} />
    )
  }
}


// Sheet.propTypes = {
//   height: PropTypes.string.isRequired
// };

Sheet.defaultProps = {
  drawer: "bottom"
}

export class Confirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    Confirm.current = this;
  }

  open(title, content, onOk, onCancel) {
    this.setState({
      title, content, onOk, onCancel, open: true
    });
  }

  cancel() {
    let { onCancel } = this.state;
    if (onCancel) onCancel();
    this.setState({ open: false });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  render() {
    let { title, content } = this.state;
    return (
      <Dialog
        maxWidth={"lg"}
        open={this.state.open}
      >
        <p className="c-text-s4 m-3 c-text-sm-s5 m-sm-4 c-mb-2" style={{ minWidth: runtime.pc ? 500 : 200 }}>{title}</p>
        {
          content ?
            <DialogContent>
              <DialogContentText>
                {content}
              </DialogContentText>
            </DialogContent> : null
        }
        <DialogActions className="c-confirm-actions">
          <Button className="c-w-vsm-100" onClick={() => this.ok()} color="primary">
            确定
          </Button>
          <Button className="c-w-vsm-100" onClick={() => this.cancel()} color="secondary" autoFocus>
            取消
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    Alert.current = this;
  }

  open(title, content, onOk) {
    this.setState({
      title, content, onOk, open: true
    });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  render() {
    let { title, content } = this.state;
    return (
      <Dialog
        maxWidth={"lg"}
        open={this.state.open}
      >
        <p className="c-text-s4 m-3 c-text-sm-s5 m-sm-4 c-mb-2" style={{ minWidth: runtime.pc ? 500 : 200 }}>{title}</p>
        {
          content ?
            <DialogContent>
              <DialogContentText>
                {content}
              </DialogContentText>
            </DialogContent> : null
        }
        <DialogActions className="c-alert-actions">
          <Button className="c-w-vsm-100" onClick={() => this.ok()} color="primary">
            确定
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}



export class SweetConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    SweetConfirm.current = this;
  }

  open({ title, content, onOk, onCancel, okText, cancelText, type }) {
    this.setState({
      title, content, onOk, onCancel, open: true, okText, cancelText, type
    });
  }

  cancel() {
    let { onCancel } = this.state;
    if (onCancel) onCancel();
    this.setState({ open: false });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }


  title() {
    let { title } = this.state;
    if (!title) return '';
    return <p className="mb-0 c-text-s3">{title}</p>
  }

  render() {
    let { title, content, open, okText, cancelText, type } = this.state;
    let p = {};
    if (type) p[type] = true; else p.warning = true;
    return (
      <_SweetAlert show={open}
        {...p}
        showCancel
        confirmBtnText={okText || "确定"}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        cancelBtnText={cancelText || "取消"}
        title={this.title()}
        closeOnClickOutside = {false}
        onConfirm={() => { this.ok(); }}
        onCancel={() => { this.cancel(); }}
      >
        {content}
      </_SweetAlert>
    );
  }
}



export class SweetAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    SweetAlert.current = this;
  }

  open({ title, content, onOk, okText, type }) {
    this.setState({
      title, content, onOk, open: true, okText, type
    });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  getOKColor() {
    let { type } = this.state;
    if (type == "success") return "success";
    return "danger";
  }

  render() {
    let { title, content, open, okText, type } = this.state;
    let p = {};
    if (type) p[type] = true; else p.warning = true;
    return (
      <_SweetAlert show={open}
        {...p}
        showCancel
        confirmBtnText={okText || "确定"}
        confirmBtnBsStyle={this.getOKColor()}
        title={title || ''}
        showCancel={false}
        onConfirm={() => { this.ok(); }}
      >
        {content}
      </_SweetAlert>
    );
  }
}



export class Snackbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      vertical: null,
      horizontal: null,
    }
    Snackbar.current = this;
    this.list = [];
    this.timer = null;
  }

  open(p) {
    this.handleRequestClose();
    this._open(p);
  }

  _open(p) {
    p = Util.type(p) === "string" ? { message: p } : p;
    let { message, horizontal, vertical } = p;
    this.setState({
      message, horizontal, vertical, open: true
    });
    this.timer = setTimeout(() => {
      this.handleRequestClose();
    }, 3000);
  }

  handleRequestClose = () => {
    clearTimeout(this.timer);
    this.setState({ open: false });
  };

  render() {
    let { vertical, horizontal, message, open } = this.state;
    horizontal = horizontal || "center";
    vertical = vertical || "bottom";
    return (
      <_Snackbar
        onClick={() => { this.handleRequestClose(); }}
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        // onClose={this.handleRequestClose}
        ContentProps={{
          'aria-describedby': 'snackbar-message-id',
        }}
        message={<span id="snackbar-message-id">{message}</span>}
      />
    );
  }
}



export const Message = {
  confirm(title, content, onOk, onCancel) {
    if (Util.type(content) == "function") {
      onCancel = onOk;
      onOk = content;
      content = null;
    }
    var c = Confirm.current;
    c.open(title, content, onOk, onCancel);
  },
  alert(title, content, onOk) {
    if (Util.type(content) == "function") {
      onOk = content;
      content = null;
    }
    var c = Alert.current;
    c.open(title, content, onOk);
  },
  warning(title) {
    Message.sweetAlert({ title });
  },
  sweetConfirm(p) {
    var c = SweetConfirm.current;
    c.open(p);
  },
  sweetAlert(p) {
    var c = SweetAlert.current;
    c.open(p);
  },
  snackbar(p) {
    Snackbar.current.open(p);
  }
}